import {
  // deposit
  START_LOAD_DEPOSIT_INFO,
  END_LOAD_DEPOSIT_INFO,
  SET_DEPOSIT_INFO,
  SET_DEPOSIT_ERROR,
  SET_DEPOSIT_HISTORY,
  REMOVE_DEPOSIT_ERROR
} from '@/state/mutationTypes'

import api, { getData } from '@/axiosConfig'
const gemnoteAPI = api()

export const depositStore = {
  namespaced: true,
  state: {
    errors: [],
    depositList: [],
    deposit: {
      amount: 0.0,
      usedAmount: 0.0,
      totalAmount: 0.0
    },
    depositLoading: false,
    depositLoaded: false,
    submissionSuccessDeposit: false
  },
  mutations: {
    [START_LOAD_DEPOSIT_INFO](state) {
      state.depositLoading = true
      state.depositLoaded = false
    },

    [END_LOAD_DEPOSIT_INFO](state) {
      state.depositLoading = false
      state.depositLoaded = true
    },

    [SET_DEPOSIT_INFO](state, depositObject) {
      state.deposit = depositObject
    },
    [SET_DEPOSIT_ERROR](state, payload) {
      state.errors = payload
    },
    [REMOVE_DEPOSIT_ERROR](state) {
      state.errors = []
    },
    [SET_DEPOSIT_HISTORY](state, payload) {
      state.depositList = payload
    }
  },
  actions: {
    async getDeposit({ commit }) {
      try {
        commit(START_LOAD_DEPOSIT_INFO)
        const response = await gemnoteAPI.get('team/deposit')
        const data = getData(response)
        commit(SET_DEPOSIT_INFO, data.attributes)
        commit(END_LOAD_DEPOSIT_INFO)
      } catch (err) {
        commit(SET_DEPOSIT_INFO, 0.0)
      }
    },
    async getDepositHistory({ commit }) {
      try {
        const response = await gemnoteAPI.get('team/payments')
        const data = getData(response)
        let depositHistory = []
        let imagePath = require('../assets/download-icon.svg')
        data.map(deposit => {
          depositHistory.push({
            id: deposit.id,
            type: deposit.type,
            amount: deposit.attributes.amount,
            receiptUrls: `<a href="${deposit.attributes.receiptUrls}" target="_blank"><img src="${imagePath}" class="downloand-invoive" /></a>`
          })
        })
        commit(SET_DEPOSIT_HISTORY, depositHistory)
      } catch (error) {
        commit(SET_DEPOSIT_HISTORY, [])
        let errors = []
        if (error.response) {
          let { errors } = error.response.data
          commit(SET_DEPOSIT_ERROR, errors)
          setTimeout(() => commit(REMOVE_DEPOSIT_ERROR), 8000)
        } else if (error.request) {
          errors.push(
            `The request was made but no response was received from the server.`
          )
          commit(SET_DEPOSIT_ERROR, errors)
        } else {
          errors.push(
            `An exception occurred while trying to load team members. No response was received from server.`
          )
          commit(SET_DEPOSIT_ERROR, errors)
        }
      }
    },
    async submitDeposit({ commit }, amountToDeposit) {
      try {
        if (amountToDeposit > 0) {
          commit(START_LOAD_DEPOSIT_INFO)
          const response = await gemnoteAPI.post('team/deposit', {
            deposit: {
              amount: amountToDeposit
            }
          })
          const data = getData(response)
          commit(SET_DEPOSIT_INFO, data.attributes)
          commit(END_LOAD_DEPOSIT_INFO)
        } else {
          let errors = []
          errors.push('Deposit amount must be greater that zero.')
          commit(SET_DEPOSIT_ERROR, errors)
        }
      } catch (err) {
        if (err.response) {
          let { errors } = err.response.data
          commit(SET_DEPOSIT_ERROR, errors[0].message)
          commit(END_LOAD_DEPOSIT_INFO)
        } else {
          let errors = []
          errors.push('An exception ocurred while trying to add new deposit.')
          commit(SET_DEPOSIT_ERROR, errors)
          commit(END_LOAD_DEPOSIT_INFO)
        }
      }
    }
  }
}
